module.exports = __webpack_public_path__ + "img/center-of-the-earth.33de4c26.jpg";